import { TTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus.types';

import { TAccount } from '../Accounts/accounts.types';

export type TSegmentationEligibilityArgs = {
    country: string | undefined;
    productType: TAccount['product_type'] | undefined;
    loanStatus: TAccount['loan_status'];
    topupStatus: TTopUpStatus;
    isRevolvingCreditFacility: boolean;
};

const SEGMENTABLE_PRODUCT_TYPE = 'credit_facility';

export const getIsSegmentationEligible = ({
    country,
    productType,
    loanStatus,
    topupStatus,
    isRevolvingCreditFacility
}: TSegmentationEligibilityArgs): boolean =>
    [
        country === 'UK',
        productType === SEGMENTABLE_PRODUCT_TYPE,
        loanStatus !== 'ended' && loanStatus !== 'overdue',
        topupStatus !== 'TOPUP_PENDING',
        !isRevolvingCreditFacility
    ].every(Boolean);
